define('ordersDetailMessagesBodyMessageView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'imageUtils',
  'dateUtils',
  'commentEditView',
  'settings',
  'ordersDetailMessagesBodyMessageAttachmentsView',
  'template!ordersDetailMessagesBodyMessageView'
], function(
  App,
  Module,
  Backbone,
  Marionette,
  _,
  ImageUtils,
  DateUtil,
  EditView,
  Settings,
  AttachmentsView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({    
    className: 'message-view',
    template: Tpl,
    EditView: EditView,

    attributes: function() {
      var origin = '';
      if(this.model.get('userpid').secId === Settings.get('currentUser').secId)
        origin = 'from';
      else
        origin = 'to';

      return {
        'data-origin': origin
      };
    },

    ui: {
      date: '.date',
      name: '.name',
      logo: '.logo',
      body: '.body',
      buttons: '.buttons'
    },

    regions: {
      attachmentsRegion: '.attachments-region'
    },

    events: {
      'click .btn-delete': 'onDelete'
    },

    onRender: function() {
      this.ui.date.html(DateUtil.toMDYHHMMFormat(this.model.get('msgDate')));

      this.ui.name.html('-');

      var user = this.model.get('userpid');

      var logo = '';

      if(user) {       
        logo = ImageUtils.getLogo(user.logo, user.email);
        this.ui.name.html(user.firstName + ' ' + user.lastName);        
      }

      if(logo) {
        this.ui.logo.css('background-image', 'url("'+ logo +'")');
        this.ui.logo.show();
      } else {
        this.ui.logo.hide();
      }

      if(this.model.get('content'))
        this.ui.body.html(this.model.get('content').replaceAll('\n', '<br>'));
      else
        this.ui.body.html('');

      if(this.options.showButtons === false) {
        this.ui.buttons.hide();
      }

      //---------------------------
      this.attachmentsView = new AttachmentsView({model: this.model});
      this.getRegion('attachmentsRegion').show(this.attachmentsView);
    },

    onDelete: function () {
      this.trigger('delete');
    }
  });   
});
